import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Spinner from '@fenderdigital/react-spinner';

const DeveloperConsole = ({
  createdAt,
  children,
  durationForMilestone,
  email,
  firstName,
  isEnabled,
  isLoadingStreaks,
  lastName,
  loggedIn,
  sessionData,
  sessionLengthInMins,
  setCreatedAt,
  streaksData,
  streaksError,
  subscriptionStatus,
  setStreak,
  removeStreak,
  setSessionLength,
}) => {
  const [ConsoleContent, setConsoleContent] = useState(null);
  const [isLoadingConsoleContent, setIsLoadingConsoleContent] = useState(false);
  let content = null;
  if (isEnabled) {
    if (ConsoleContent) {
      content = (
        // We can't set ConsoleContent directly because the functional component
        // gets confused for a state function
        <ConsoleContent.default
          email={email}
          firstName={firstName}
          lastName={lastName}
          subscriptionStatus={subscriptionStatus}
          loggedIn={loggedIn}
          streaksData={streaksData}
          durationForMilestone={durationForMilestone}
          isLoadingStreaks={isLoadingStreaks}
          sessionLengthInMins={sessionLengthInMins}
          streaksError={streaksError}
          createdAt={createdAt}
          sessionData={sessionData}
          setCreatedAt={setCreatedAt}
          setStreak={setStreak}
          removeStreak={removeStreak}
          setSessionLength={setSessionLength}
        />
      );
    } else {
      content = <Spinner fullPage />;
      if (!isLoadingConsoleContent) {
        setIsLoadingConsoleContent(true);
        import(/* webpackChunkName: "DeveloperConsole" */ './DeveloperConsoleContent').then(
          setConsoleContent,
        );
      }
    }
  }

  return (
    <div className="console-wrapper">
      {children || null}
      {content}
    </div>
  );
};

DeveloperConsole.propTypes = {
  createdAt: PropTypes.string,
  email: PropTypes.string,
  durationForMilestone: PropTypes.number,
  firstName: PropTypes.string,
  children: PropTypes.node,
  isEnabled: PropTypes.bool,
  isLoadingStreaks: PropTypes.bool,
  lastName: PropTypes.string,
  loggedIn: PropTypes.bool,
  removeStreak: PropTypes.func,
  sessionLengthInMins: PropTypes.number,
  sessionData: PropTypes.shape({}),
  setSessionLength: PropTypes.func,
  setStreak: PropTypes.func,
  setCreatedAt: PropTypes.func,
  streaksData: PropTypes.shape({}),
  streaksError: PropTypes.string,
  subscriptionStatus: PropTypes.string,
};

DeveloperConsole.defaultProps = {
  createdAt: '',
  email: null,
  durationForMilestone: null,
  firstName: null,
  children: null,
  getStreak: () => {},
  isEnabled: false,
  isLoadingStreaks: null,
  lastName: null,
  loggedIn: null,
  removeStreak: () => {},
  sessionData: null,
  sessionLengthInMins: null,
  setSessionLength: () => {},
  setStreak: () => {},
  setCreatedAt: () => {},
  streaksData: null,
  streaksError: null,
  subscriptionStatus: null,
};

export default DeveloperConsole;
